import styled from 'styled-components';
import { media } from '../../../Utils/mediaQueries';
import { Text } from '../../UI/Text';

export const ProfileStatsContainer = styled.div`
    padding-top: 20px;
    padding-bottom: 10px;
    width: 470px;
    margin: 0 auto;
    display: flex;
    align-items: center;

    ${media.phone`
        width: 360px;
        // padding-top: 50px;
    `};
`;

export const AvatarContainer = styled.div``;

export const StatsContainer = styled.div`
    margin-left: 36px;

    ${media.phone`
        margin-left: 10px;
    `};
`;

export const HorizontalMargin = styled.div`
    margin-right: 11px;

    ${media.phone`
        margin-right: 5px;
    `};
`;

export const CountWrapper = styled.div`
    margin: 4px;
`;

export const UserNameContainer = styled(Text)`
    font-size: 33px;
    font-weight: bold;
    line-height: 1;

    ${media.phone`
        font-size: 29px;
    `};
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/ProfileStats/style.js